/**
 * Internal dependencies
 */
import {
    CURRENT_DISPATCH_RECEIVE,
    CURRENT_DISPATCH_REQUEST,
    CURRENT_DISPATCH_REQUEST_SUCCESS,
    CURRENT_DISPATCH_REQUEST_FAILURE,
} from 'state/action-types';

import cscom from 'lib/customer-site-api';
import {getCurrentDispatch, requestingCurrentDispatch} from 'state/current-dispatch/selectors';

/**
 * [description]
 *
 * @param  {[type]}         [description]
 * @return {[type]}         [description]
 */
export const setCurrentDispatch = (dispatchplan) => {
    return {
        type: CURRENT_DISPATCH_RECEIVE,
    };
};

/**
 * [description]
 *
 * @param  {[type]} ) [description]
 * @return {[type]}   [description]
 */
export const requestCurrentDispatch = () => (dispatch) => {
    dispatch({
        type: CURRENT_DISPATCH_REQUEST,
    });

    return cscom
        .dispatchPlan()
        .get()
        .then((dispatchplan) => {
            dispatch({
                type: CURRENT_DISPATCH_REQUEST_SUCCESS,
            });
            dispatch({
                type: CURRENT_DISPATCH_RECEIVE,
                payload: {
                    dispatchplan,
                },
            });

            return dispatchplan;
        })
        .catch((error) => {
            if (error == 'Error: Not Found') {
                dispatch({
                    type: CURRENT_DISPATCH_REQUEST_SUCCESS,
                });
                return;
            }
            dispatch({
                type: CURRENT_DISPATCH_REQUEST_FAILURE,
                error,
            });
        });
};

/**
 * [description]
 * 
 * @param  {...[type]} props) [description]
 * @return {[type]}           [description]
 */
export const requestCurrentDispatchIfNotRequested = (...props) => async (dispatch, getState) => {
    
    const currentDispatch = getCurrentDispatch(getState());
    const requesting = requestingCurrentDispatch(getState());

    if (!currentDispatch && requesting == false) {
        return dispatch(requestCurrentDispatch(...props));
    }

    return currentDispatch;
}
